import { useCallback } from "react";
import { Grid, Divider, Typography } from "@material-ui/core";
import { Box, Button, List, ListItem } from "~/components/UI";
import Highlighter from "react-highlight-words";
import history from "~/packages/history";
import ROUTES from "~/constants/routes";
import { useTranslation } from "react-i18next";

interface OutboundVirtualTerminalsResultProps {
  data?: Api.SearchResult<Api.UserSearchResult>;
  searchQuery: string;
}

const User = ({
  outboundVirtualTerminal,
  searchQuery,
}: {
  searchQuery: string;
  outboundVirtualTerminal: Api.UserSearchResult;
}) => {
  const openGroup = useCallback(() => {
    history.push(
      `${ROUTES.OUTBOUND_VIRTUAL_TERMINALS}?id=${outboundVirtualTerminal.id}`
    );
  }, [outboundVirtualTerminal.id]);

  return (
    <ListItem button onClick={openGroup}>
      <Typography variant="body2" color="textSecondary">
        <Typography variant="body2" component="span" color="primary">
          ID
        </Typography>
        :{" "}
        <Highlighter
          searchWords={[searchQuery]}
          textToHighlight={outboundVirtualTerminal.id}
        />
      </Typography>
      <Divider />
    </ListItem>
  );
};

/**
 * @memberof GlobalSearch
 * @component
 * @desc Render of search results for the OutboundVirtualTerminals catalog.
 * @property {string} searchQuery - the text we are looking for
 * @property {Api.SearchResult<Api.UserSearchResult>} data - api response
 */

const OutboundVirtualTerminals = ({
  data,
  searchQuery,
}: OutboundVirtualTerminalsResultProps) => {
  const { t } = useTranslation();

  const onShowAll = useCallback(() => {
    setTimeout(() => {
      history.push(
        `${ROUTES.OUTBOUND_VIRTUAL_TERMINALS}?search=${searchQuery}`
      );
    }, 0);
  }, [searchQuery]);

  if (data && data.count) {
    return (
      <Box mb={4}>
        <Box py={4}>
          <Grid container alignItems="center">
            <Grid item sm>
              <Typography variant="subtitle1">
                {t("title.catalogOutboundVirtualTerminals")} ({data.count})
              </Typography>
            </Grid>
            <Grid item>
              <Button variant="outlined" onClick={onShowAll}>
                {t("button.showAll")}
              </Button>
            </Grid>
          </Grid>
        </Box>
        <List>
          {data.data.map((u, index) => (
            <User
              key={index}
              searchQuery={searchQuery}
              outboundVirtualTerminal={u}
            />
          ))}
        </List>
      </Box>
    );
  } else {
    return null;
  }
};

export default OutboundVirtualTerminals;
